class SaleCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Event and time-related attributes
    this.startDate = parseInt(this.getAttribute('data-progress-start-date')); // Event start
    this.currentDate = parseInt(this.getAttribute('data-start-date'));       // Current time
    this.endDate = parseInt(this.getAttribute('data-end-date'));             // Event end

    // Fetch the initial start percentage from the [data-progress-percent] element, or use default 91%
    this.startPercent = this.dataset.initialProgress ? parseFloat(this.dataset.initialProgress) : 91;
    this.targetPercent = 99.99;     // Ending percentage

    // Calculate the total event duration in seconds
    this.totalDurationInSeconds = this.endDate - this.startDate;

    // Calculate the progress rate per second
    this.progressPerSecond = (this.targetPercent - this.startPercent) / this.totalDurationInSeconds;

    this.updateCountdown(); // Initial update
    this.intervalId = setInterval(() => this.updateCountdown(), 1000); // Update every second
  }

  disconnectedCallback() {
    clearInterval(this.intervalId);
  }

  calculateRemainingTime() {
    const differenceInSeconds = this.endDate - this.currentDate;

    if (differenceInSeconds <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const days = Math.floor(differenceInSeconds / (3600 * 24));
    const hours = Math.floor((differenceInSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((differenceInSeconds % 3600) / 60);
    const seconds = differenceInSeconds % 60;

    return { days, hours, minutes, seconds };
  }

  calculateProgressPercent() {
    const elapsedSeconds = this.currentDate - this.startDate;
    // If the elapsed time is less than or equal to 0, we are at the start percentage
    if (elapsedSeconds <= 0) return this.startPercent;

    // Calculate the progress percentage based on the elapsed time
    let progressPercent = this.startPercent + elapsedSeconds * this.progressPerSecond;
    // Cap the progress at the target percentage
    return Math.min(progressPercent, this.targetPercent).toFixed(1);
  }

  updateCountdown() {
    const remainingTime = this.calculateRemainingTime();
    const progressPercent = this.calculateProgressPercent();

    // Update countdown timers
    if (this.querySelector('.sale-countdown__cards')) {
      this.querySelector('.sale-countdown__days').textContent = remainingTime.days;
      this.querySelector('.sale-countdown__hours').textContent = remainingTime.hours;
      this.querySelector('.sale-countdown__min').textContent = remainingTime.minutes;
      this.querySelector('.sale-countdown__secs').textContent = remainingTime.seconds;
    }


    // Update progress percentage
    if (this.querySelector('.sale-countdown__range')) {
       this.querySelector('.sale-countdown__range').style.setProperty('--sale-percentage', `${progressPercent}%`);
      const progressElement = this.querySelector('[data-progress-percent]');
      if (progressElement) {
        progressElement.textContent = `${progressPercent}%`;
      }
      if (progressPercent > 90) {
        this.querySelector('.sale-countdown__footer')?.classList.add('highlight');
      }
    }
    if (progressPercent > 90) {
        this.classList.add('highlight');
    }


    // Increment current time by 1 second for the next calculation
    this.currentDate += 1;
  }
}

customElements.define('sale-countdown', SaleCountdown);

function detectAndRemoveClass() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const element = document.querySelector('.js-android-ios-only');

  if (element) {
      if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) {
          element.classList.remove('js-android-ios-only');
      } else {
      }
  } else {
  }
}

document.addEventListener("DOMContentLoaded", detectAndRemoveClass);

if (!customElements.get('spin-to-win')) {
  customElements.define('spin-to-win', class extends HTMLElement {
    constructor() {
      super();
      this.container = this;
      this.startButton = this.querySelector(".spin-to-win__start-button");
      this.stopButton = this.querySelector(".spin-to-win__stop-button");
      this.wheel = this.querySelector(".icon-spin-to-win");
      this.klaviyoForm = this.querySelector(".klaviyo-embed__container");
      this.testMessage = this.querySelector(".test-message");
      this.backgroundGift = this.getAttribute("background");
      this.postScript = this.querySelector(".spin-to-win__postscript")
      this.header = this.querySelector(".spin-to-win__header");
      this.spinModal = document.querySelector(".spin-modal");
      this.spinInterval;
      this.animationFrame;
      this.speed = 10;
      this.maxSpeed = 20;
      this.angle = 0;
      this.stop = false;
      this.init();
    }

    init() {
      this.startButton.addEventListener("click", () => {
        this.container.classList.add("step-2");
        this.spinStart();
        console.log("test");
        console.log(this.startButton.querySelector('svg'))
        if (this.startButton.querySelector('svg') != undefined && this.klaviyoForm.querySelector('button') != undefined) {
          console.log("add svg")
          const sourceSvg = this.startButton.querySelector('svg');
          const clone = sourceSvg.cloneNode(true);
          const clone2 = sourceSvg.cloneNode(true);
          this.klaviyoForm.querySelector('button').prepend(clone);
          this.klaviyoForm.querySelector('button').append(clone2);
        }
      });

      if (this.klaviyoForm != undefined) {
        console.log("observe klaviyo")
        
        this.observer = new MutationObserver(this.handleMutation.bind(this));
        this.observer.observe(this.klaviyoForm, {
          subtree: true,
          childList: true,
        });
      }

      if (this.postScript != undefined) {
        this.postScript.querySelector("form").addEventListener("submit",() => {
          console.log("Post script submitted")
          this.postScript.classList.add("hidden");
          this.container.classList.remove("step-2");
          this.container.classList.add("step-3");
          this.klaviyoForm.style.display = "block";
          this.spinModal.classList.add("final-step");
          this.spinModal.addEventListener("click", () => {
            this.spinModal.removeAttribute("open");
          })
          setTimeout(() => {
            if (this.startButton.querySelector('svg') != undefined && this.klaviyoForm.querySelector('button') != undefined) {
              console.log("add svg")
              const sourceSvg = this.startButton.querySelector('svg');
              const clone = sourceSvg.cloneNode(true);
              const clone2 = sourceSvg.cloneNode(true);
              this.klaviyoForm.querySelector('button').prepend(clone);
              this.klaviyoForm.querySelector('button').append(clone2);
            }
          }, 100)
          // fetch(`/discount/${this.dataset.discount}`, { method: "GET" }).then(() => {
          //   this.setCookie("free-gift", this.dataset.gift);
          //   let addOnSwitch = document.querySelector(`[data-product-id="${this.dataset.gift}"]`);
          //   if (addOnSwitch != undefined) {
          //     let priceParent = addOnSwitch.closest(".bundle-cards__add-on").querySelector(".bundle-cards__add-on-price");
          //     priceParent.classList.add("bundle-cards__card-upsell-price");
          //     priceParent.querySelector(".money").classList.add("bundle-cards__card-compare-price");
          //     priceParent.innerHTML += '<div class="bundle-cards__card-regular-price"><span class="money bold">FREE</span></div>';
          //   }
          // });
        })
      }

      setTimeout(() => {
        if (this.backgroundGift != undefined) {
          this.closest(".drawer").querySelector('[part="overlay"]').style.background = this.backgroundGift.replace("600x", window.innerWidth + "x");
        }
      }, 2500)
      setTimeout(() => {
      }, 4000)
    }

    enableFreeGift() {
      if (this.dataset.gift != undefined) {
        this.setCookie("free-gift", this.dataset.gift, 1209600);
        let addOnSwitch = document.querySelector(`[data-product-id="${this.dataset.gift}"]`);
        console.log("CHECK THE INBOX")
        console.log(addOnSwitch)
        if (addOnSwitch != undefined) {
          addOnSwitch.checked = true;
          addOnSwitch.dispatchEvent(new Event("change"));
        }
      }
    }

    spinAnimation() {
      this.speed = Math.min(this.speed * 1.05, this.maxSpeed);
      this.angle = (this.angle + this.speed) % 360;
      this.wheel.style.transform = `rotate(${this.angle}deg)`;
      this.animationFrame = requestAnimationFrame(this.spinAnimation.bind(this));
    }

    slowDown() {
      this.speed *= 0.95;
      this.angle += this.speed;
      this.wheel.style.transform = `rotate(${this.angle}deg)`;
      if (this.speed > 0.2) {
        this.animationFrame = requestAnimationFrame(this.slowDown.bind(this));
      } else {
        setTimeout(() => {
          this.wheel.closest(".spin-to-win__wheel").style.display = "none";
          
          this.querySelector('.icon-spin-to-win-triangle').style.display = "none";
          if (this.postScript != undefined) {
            this.postScript.classList.remove("hidden");
          } else {
            this.header.style.display = "none";
            this.klaviyoForm.style.display = "block";
            this.klaviyoForm.style.border = "none";
          }
        }, 600);
        
      }
    }

    // Helper: read current rotation in degrees (handles matrix & matrix3d)
    getCurrentAngle() {
      const t = getComputedStyle(this.wheel).transform;
      if (!t || t === 'none') return 0;

      // matrix(a, b, c, d, e, f)
      if (t.startsWith('matrix(')) {
        const m = t.match(/matrix\(([^)]+)\)/)[1].split(',').map(parseFloat);
        const a = m[0], b = m[1];
        return Math.round(Math.atan2(b, a) * (180 / Math.PI));
      }

      // matrix3d(m11, m12, m13, ...):
      if (t.startsWith('matrix3d(')) {
        const m = t.match(/matrix3d\(([^)]+)\)/)[1].split(',').map(parseFloat);
        const a = m[0], b = m[1]; // same as 2D plane
        return Math.round(Math.atan2(b, a) * (180 / Math.PI));
      }

      return 0;
    }
    
    // Lighter/smoother spin start
    spinStart() {
      if (this.spinning) return;

      // Prep
      this.spinning = true;
      this.wheel.classList.remove('idle');
      this.wheel.style.willChange = 'transform';

      // Read (before writes)
      const currentAngle = this.getCurrentAngle();
      this.currentAngle = currentAngle; // cache for future steps if needed

      // Write initial state
      this.wheel.style.transition = 'none';
      this.wheel.style.transform = `rotate(${currentAngle}deg)`;

      // Next frame: apply the “nudge” transition
      const startNudge = () => {
        // Use a gentle curve; a bit shorter for mobile responsiveness
        this.wheel.style.transition = 'transform 320ms cubic-bezier(.2,.6,.2,1)';
        this.wheel.style.transform = `rotate(${currentAngle - 60}deg)`;

        const onEnd = () => {
          this.wheel.removeEventListener('transitionend', onEnd);
          // Clear transition for the continuous spin loop
          this.wheel.style.transition = 'none';
          this.wheel.style.willChange = '';

          // Respect reduced motion
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            // If you want, you can short-circuit here or do a minimal update:
            // return;
          }

          // Hand off to your existing rAF-driven spinAnimation
          this.animationFrame = requestAnimationFrame(() => this.spinAnimation());
        };

        this.wheel.addEventListener('transitionend', onEnd, { once: true });
      };

      // Double-rAF ensures style is committed before transitioning (smoother on mobile GPUs)
      requestAnimationFrame(() => requestAnimationFrame(startNudge));
    }


    spinStop() {
      cancelAnimationFrame(this.animationFrame);
      console.log("SPIN STOP");
      this.enableFreeGift();
      this.animationFrame = requestAnimationFrame(this.slowDown.bind(this));
    }

    handleMutation(mutations) {
      console.log("has change")
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          console.log(mutation)
            mutation.removedNodes.forEach((node) => {
              console.log(node)
              
              console.log(node.tagName.toLowerCase() + " : " + node.className?.toString())
                if (node.nodeType === 1 && node.tagName.toLowerCase() === 'input') {
                    this.spinStop();
                    this.klaviyoForm.style.display = "none";
                    
                    this.spinning = false;
                }
                if (node.nodeType === 1 && node.tagName.toLowerCase() === 'div' && (node.id?.includes("form") || node.className?.toString().includes("form"))) {
                    this.spinStop();
                    this.klaviyoForm.style.display = "none";
                    
                    this.spinning = false;
                }
                if (node.nodeType === 3 && node.textContent?.includes("stop the wheel")) {
                  this.spinStop();
                  this.klaviyoForm.style.display = "none";
                  this.spinning = false;
                  return;
                }

                if (
                  node.nodeType === 1 &&
                  node.textContent?.toLowerCase().includes("stop the wheel")
                ) {
                  
                  this.spinStop();
                  if (this.postScript != undefined) {
                    this.klaviyoForm.style.display = "none";
                  } else {
                    this.spinModal.classList.add("final-step");
                  }
                  return;
                }
                if (node.nodeType === 1 && node.tagName.toLowerCase() === 'form') {
                  this.closest("x-drawer").removeAttribute("open");
                }
            });
        }
      });
    }
    setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
  })
}

// Global Redirect
if (!customElements.get('global-redirect')) {
  customElements.define('global-redirect', class extends HTMLElement {
    constructor() {
      super();
      setTimeout(() => {
        this.globalRedirect = document.querySelector('#global-redirect');
        this.languagePopOver = document.querySelector('#global-redirect-language');
        this.geoDetails = JSON.parse(this.dataset.redirect);
        this.countryInput = this.querySelector('#global-redirect-country-value');
        this.languageInput = this.querySelector('[aria-controls="global-redirect-language"]');
        this.submit = document.querySelector('[global-redirect-submit]');
        const observer = new MutationObserver((mutations_list) => {
          setTimeout(()=>{
            this.updateLanguage();
          }, 10);
        });
        observer.observe(this.countryInput, { subtree: false, childList: true });
        this.countryOptions = document.querySelector('#global-redirect-country').querySelectorAll('[role="option"]');
        this.languageOptions = this.querySelector('#global-redirect-language').querySelectorAll('[role="option"]');
  
        var ipChecker = setInterval(()=> {
          if (typeof _ipgeolocation != undefined && typeof _ipgeolocation != null && typeof _ipgeolocation != "undefined") {
            _ipgeolocation.getGeolocation(this.ipResponse.bind(this), "483d2a41026e434682c0c9a0331f62ac");
            clearInterval(ipChecker);
          }
        }, 100)
        this.initButtons();
        this.initUTM();
      }, 100)
    }
    setRedirectVisibility(isVisible) {
      if (!this.globalRedirect) return;

      if (isVisible) {
        this.globalRedirect.removeAttribute('hidden');
        this.globalRedirect.removeAttribute('inert');
        this.globalRedirect.setAttribute('aria-hidden', 'false');
      } else {
        this.globalRedirect.removeAttribute('open');
        this.globalRedirect.setAttribute('hidden', '');
        this.globalRedirect.setAttribute('inert', '');
        this.globalRedirect.setAttribute('aria-hidden', 'true');
      }
    }
    initUTM() {
      const params_array = ["utm_source", "utm_medium","utm_id","utm_content","utm_term","utm_campaign"];
      this.searchParamsAsString = new URLSearchParams(window.location.search);
      var params = "";
      this.cookieParams = this.getCookie("utm_params");
      for (let i = 0; i < params_array.length; i++) {
        var utm = this.searchParamsAsString.get(params_array[i]);
        if (utm != "" && utm != null && utm != undefined) {
          params += "&" + params_array[i] + "=";
          params += utm;
        }        
      }
      if (params != "") {
        this.setCookie("utm_params", params);
      }
      if (this.cookieParams != "" || params != "") {
        if (this.cookieParams != "" && this.cookieParams != " " && this.cookieParams != undefined) {
          this.params = this.cookieParams;
        } else {
          this.params = params;
        }
      }
      if (this.params != undefined) {
        var local_selector = document.querySelectorAll('localization-selector');
        local_selector.forEach((selector) => {
          var links = selector.querySelectorAll('a');
          links.forEach((link) => {
            link.setAttribute('href', link.getAttribute('href') + this.params);
          })
        })
      }
    }
    initButtons() {
      this.countryOptions.forEach((option) => {
        option.addEventListener('click', () => {
          document.querySelector('#global-redirect-country').removeAttribute('open');
          this.countryInput.innerHTML = option.innerHTML;
          this.countryInput.setAttribute('tld', option.getAttribute('value'));
        })
        // Add keyboard support (Enter, Space)
        option.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            option.click();
          }
        })
      })
      this.languageOptions.forEach((option) => {
        option.addEventListener('click', () => {
          this.languagePopOver.removeAttribute('open');
          this.languageInput.setAttribute('tld', option.getAttribute('value'));
        });
        // Add keyboard support (Enter, Space)
        option.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            option.click();
          }
        })
      })
      this.submit.addEventListener('click', ()=> {
        var country_tld = this.countryInput.getAttribute('tld');
        var language_tld = this.languageInput.getAttribute('tld');
        var current_url = window.location.href;

        // No country resolved (geolocation blocked/failed) -> submitting has no
        // target; close the modal instead of throwing and leaving it stuck open.
        if (!country_tld) {
          this.setCookie('fa-redirect', false, 365);
          if (typeof this.globalRedirect.hide === 'function') { this.globalRedirect.hide(); }
          else { this.globalRedirect.removeAttribute('open'); }
          return;
        }

        var new_tld = country_tld + "/" + language_tld;
        var country_match = this.geoDetails.countries.findIndex(x => x == language_tld);
        var language_index = this.geoDetails.tlds.findIndex(x => x == country_tld);
        var language_count = language_index != -1 ? this.geoDetails.country_languages[language_index].split(',').length : 1;

        if (language_index == -1) {
          new_tld = country_tld;
        } else if (country_tld == ( "." + language_tld) || this.geoDetails.country_languages[language_index].split(',')[0] == language_tld) {
          new_tld = country_tld;
        } else if (language_count == 1) {
          new_tld = country_tld;
        } else if (country_match != "-1") {
          new_tld = this.geoDetails.tlds[country_match];
        }

        // Country domains serve their language at the ROOT. Carrying a locale
        // prefix across domains (/nl/products/x -> freakathlete.nl/nl/products/x)
        // lands on a 404, so strip it when switching domains.
        var newLocation;
        try {
          var target = new URL(current_url);
          target.hash = '';
          if (new_tld != this.geoDetails.current_tld && new_tld.indexOf('/') == -1) {
            target.host = target.host.replace(this.geoDetails.current_tld, new_tld);
            var segments = target.pathname.split('/');
            if (segments[1] && this.geoDetails.languages.indexOf(segments[1].toLowerCase()) != -1) {
              segments.splice(1, 1);
              target.pathname = segments.join('/') || '/';
            }
          } else if (new_tld != this.geoDetails.current_tld) {
            target = new URL(current_url.replace(this.geoDetails.current_tld, new_tld));
          }
          newLocation = target.origin + target.pathname;
        } catch (e) {
          newLocation = current_url.replace(this.geoDetails.current_tld, new_tld).split('?')[0];
        }
        window.location.href = newLocation + "?no_rule=true" + (this.params || "");
      })
      // Add Escape key support to close popovers
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          document.querySelector('#global-redirect-country')?.removeAttribute('open');
          this.languagePopOver?.removeAttribute('open');
        }
      })
    }
    updateLanguage() {
      var matchingIndex = this.geoDetails.tlds.findIndex(x => x == this.countryInput.getAttribute('tld'));
      var languages = this.geoDetails.country_languages[matchingIndex].split(',');
      if (languages.length > 1) {
        this.languageInput.removeAttribute('hidden');
      } else {
        this.languageInput.setAttribute('hidden', "")
      }
      this.languageOptions.forEach((option) => {
        if (option.getAttribute('value') == languages[0].toLowerCase()) {
          option.setAttribute('aria-selected', true);
          option.removeAttribute('hidden');
          this.languageInput.querySelector('.selected-option').innerHTML = option.innerHTML;
          this.languageInput.setAttribute('tld', option.getAttribute('value'));
        } else if (languages.findIndex(x => x == option.getAttribute('value').trim()) != "-1") {
          option.removeAttribute('hidden');
          option.setAttribute('aria-selected', false);
        } else {
          option.setAttribute('hidden', "");
          option.setAttribute('aria-selected', false);
        }
      });

    }
    ipResponse(response) {
      const title = this.globalRedirect.querySelector('.global-redirect__country-text');
      title.textContent = title.textContent.replace('[country]', response.country_name);
      var country_tld = response.country_tld;
      if (country_tld == ".us") {
        country_tld = ".co";
      } else if (country_tld == ".uk") {
        country_tld = ".co.uk";
      }

      // country_tld
      const matchingIndex = this.geoDetails.tlds.findIndex(x => x == country_tld);
      const currentIndex = this.geoDetails.tlds.findIndex(x => x == this.geoDetails.current_tld);
      this.countryOptions.forEach((country) => {
        country.setAttribute('aria-selected', false);
      })
      this.languageOptions.forEach((option) => {
        option.setAttribute('aria-selected', false)
      })
      if (matchingIndex != "-1") {
        this.querySelector(`[value="${country_tld}"]`).setAttribute('aria-selected', true);
        this.countryInput.innerHTML = this.querySelector(`[value="${country_tld}"]`).innerHTML;
        this.countryInput.setAttribute('tld', country_tld);
      } else if (currentIndex != "-1") {
        this.countryInput.innerHTML = this.querySelector(`[value="${this.geoDetails.current_tld}"]`).innerHTML;
        this.countryInput.setAttribute('tld', this.geoDetails.current_tld);
        this.querySelector(`[value="${this.geoDetails.current_tld}"]`).setAttribute('aria-selected', true);
      } else {
        this.countryInput.innerHTML = this.countryOptions[0].innerHTML;
        this.countryInput.setAttribute('tld', this.countryOptions[0].getAttribute('value'));
        this.countryOptions[0].setAttribute('aria-selected', true);
      }
      this.checkCookie(response, country_tld);
      
    }
    checkCookie(response, country_tld) {
      const redirectCookie = this.getCookie('fa-redirect');
      var show = true;
      const searchParams = new URLSearchParams(location.search);
   
      for (let i = 0; i < this.geoDetails.excluded_pages.length; i++) {
        if (window.location.href.includes(this.geoDetails.excluded_pages[i])) {
          show = false;
        }
      }
   
      // No usable geo signal (API blocked or failed) -> never interrupt the visitor.
      if (!country_tld) {
        show = false;
      }

      // These TLDs are additional domains of the SAME storefront (EU store family).
      // A "suggestion" inside this set would send the visitor to the store they are
      // already on, so treat it as a match instead of showing the modal.
      var sameStoreTlds = ['.eu', '.nl', '.de', '.fr', '.it', '.es'];
      var sameStore = sameStoreTlds.indexOf(country_tld) != -1 && sameStoreTlds.indexOf(this.geoDetails.current_tld) != -1;

      if (searchParams.get("no_rule") == "true" || country_tld == this.geoDetails.current_tld || sameStore) {
        show = false;
        this.setCookie('fa-redirect', false, 365);
      }

      if (redirectCookie == null || redirectCookie == "null" || redirectCookie == undefined) {
        if (show) {
          this.setRedirectVisibility(true);
          if (!Shopify.designMode) {
            this.globalRedirect.setAttribute('open', '');
          }
          this.setCookie('fa-redirect', false, 365);
        } else {
          this.setRedirectVisibility(false);
        }
      } else {
        this.setRedirectVisibility(false);
      }
    }
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    }
    setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
  });
}


document.addEventListener("DOMContentLoaded", function() {
  const manageButton = document.querySelectorAll(`[data-action="manage"]`);
  manageButton.forEach((button) => {
    button.addEventListener("click", privacyBanner.showPreferences);
  })
  setTimeout(() => {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }, 2000)
  if (document.querySelector('.enable_confetti') != undefined) {
    const confettiManager = new ConfettiManager();
    confettiManager.addConfettiContinuously();
  }
});

if (!customElements.get('tab-group')) {
  customElements.define('tab-group', class TabGroup extends HTMLElement {
      constructor() {
          super();
          this.tabs = this.querySelectorAll('[tab]');
          let checker = setInterval(()=> {
            this.tabs = this.querySelectorAll('[tab]');
            if (this.tabs.length > 0) {
                clearInterval(checker)
                Array.from(this.tabs).forEach((tab)=> {
                    tab.addEventListener('click', this.setActiveTab.bind(this))
                })
            }
          }, 100)
      }
      setActiveTab(event) {
        this.tabs.forEach((tab)=> {
            tab.setAttribute('aria-selected', false);
            tab.classList.remove("active");
            if (this.dataset.controlType == "single") {
              let tab_target = document.getElementById(tab.getAttribute('aria-controls'));
              tab_target.setAttribute('hidden', true);
            }
        });

        event.currentTarget.setAttribute('aria-selected', true);
        event.currentTarget.classList.add("active");

        if (this.dataset.controlType == "single") {
          let target = document.getElementById(event.currentTarget.getAttribute('aria-controls'));
          target.removeAttribute('hidden');
          target.style.opacity = 0;
          setTimeout(()=> {
              target.style.opacity = 1;
          }, 50)
        } else {
           this.allContents = document.querySelectorAll(`[${this.dataset.controlGroup}]`)
          let contentGroup = Array.from(this.allContents).filter((content) => content.getAttribute(this.dataset.controlGroup).split(',').includes(event.currentTarget.getAttribute('aria-controls')));
          this.allContents.forEach((content) => {
            content.setAttribute('hidden', true);
          });
          contentGroup.forEach((content) => {
            content.removeAttribute('hidden');
          });
          window.scrollTo({ top: window.scrollY + contentGroup[0].getBoundingClientRect().top - 210, behavior: "smooth" });
        }
        
      }
  });
}
// End

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    const href = anchor.getAttribute('href');
    if (!href || href === '#') return; // ignore empty anchors

    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

/* ───────────────────────────────────────────────────────────────────────────
   KB AUTO-PAIR  (Benji 2026-06-29)
   When 2+ single kettlebells land in the cart, collapse each pair into the
   "FA Adjustable Kettlebell Pair" variant ($699.98 − native $150 node = $549.98).
   Odd leftover stays a single ($299.99 via its own _fa-info line).
   The swap only changes WHICH variant is in the cart — all pricing comes from
   the native Pair discount node, never from _fa-info math. Self-contained IIFE
   so a runtime error here cannot break the rest of custom.js.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  if (window.__kbAutoPairInstalled) return;
  window.__kbAutoPairInstalled = true;

  var SINGLE_VARIANT = 47741947445487; // FA031000 — single
  var PAIR_VARIANT = 47810728689903;   // FA Adjustable Kettlebell Pair — $699.98 (native −$150)
  var busy = false;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function reconcile(cart) {
    if (busy || !cart || !cart.items) return;
    var singleQty = 0;
    cart.items.forEach(function (it) { if (it.variant_id === SINGLE_VARIANT) singleQty += it.quantity; });
    if (singleQty < 2) return; // nothing to collapse

    var pairs = Math.floor(singleQty / 2);
    var leftover = singleQty % 2;
    busy = true;

    // 1) reduce the single variant down to the odd leftover (absolute set, collapses any duplicate lines)
    var updates = {}; updates[SINGLE_VARIANT] = leftover;
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    // 2) add the pair variant(s)
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: PAIR_VARIANT, quantity: pairs })
      });
    })
    .then(function () {
      busy = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(function () { busy = false; });
  }

  function onChange() { getCart().then(reconcile); }

  document.addEventListener('cart:change', onChange);
  document.addEventListener('cart:after-change', onChange);
  if (document.readyState !== 'loading') onChange();
  else document.addEventListener('DOMContentLoaded', onChange);
})();

/* ────────────────────────────────────────────────────────────────────────────
   FREE UPPER BODY KIT  (Josh 2026-10-19, USA)
   While the Leg Developer Attachment, Cable Attachment or GHD Pro Upgrade Kit is
   in the cart, one Upper Body Kit rides along free. The gift line carries the
   _fa-info "r-0" payload, so the FA Sale Function zeroes it with the label
   "FREE UPPER BODY KIT" in cart + checkout (the native buy-X-get-Y was tried
   first and does NOT combine with the per-item sale nodes — live test 10-19).
   This watcher owns the gift LINE only: add it when a qualifier arrives, take
   it out when the last qualifier leaves (recognised by its payload, not by
   session state, so a cart reopened in a new tab still cleans up), clamp it to
   one unit (r-0 is per unit). Taking the gift out by hand sticks for the
   session; a shopper's own paid Upper Body Kit is swapped for the gift.
   Self-contained IIFE like KB AUTO-PAIR above: an error here cannot break the
   rest of custom.js.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  if (window.__faFreeUbkInstalled) return;
  window.__faFreeUbkInstalled = true;

  var UBK = 45720913182959;                                               // Upper Body Kit
  var QUAL = { 45008528933103: 1, 46191149154543: 1, 46472395194607: 1 }; // Leg Developer Attachment, Cable Attachment, GHD Pro Upgrade Kit
  var GIFT = 'x;r-0-FREE UPPER BODY KIT-gift-promotion-upper-body-kit';   // the Function reprices this line to $0 per unit
  var KEY = 'fa-ubk-gift';                                                // sessionStorage: 'added' | 'declined'
  var busy = false;

  function st() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function setSt(v) { try { if (v) sessionStorage.setItem(KEY, v); else sessionStorage.removeItem(KEY); } catch (e) {} }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function done() { busy = false; document.dispatchEvent(new CustomEvent('cart:refresh')); }
  function fail() { busy = false; }

  function reconcile(cart) {
    if (busy || !cart || !cart.items) return;
    var qual = false, gift = null, own = null;
    cart.items.forEach(function (it) {
      if (QUAL[it.variant_id]) qual = true;
      if (it.variant_id === UBK) {
        if (it.properties && it.properties['_fa-info'] === GIFT) gift = it; else own = it;
      }
    });
    var s = st();
    if (gift && !qual) {                               // last qualifier left: the gift goes with it
      busy = true; setSt('');
      post('/cart/change.js', { id: gift.key, quantity: 0 }).then(done, fail);
      return;
    }
    if (gift && gift.quantity > 1) {                   // one gift per order
      busy = true;
      post('/cart/change.js', { id: gift.key, quantity: 1 }).then(done, fail);
      return;
    }
    if (qual && !gift) {
      if (s === 'declined') return;                    // shopper took the gift out on purpose
      if (s === 'added') { setSt('declined'); return; } // we added it, it is gone, a qualifier remains => they removed it
      busy = true; setSt('added');
      var p = own ? post('/cart/change.js', { id: own.key, quantity: own.quantity - 1 }) : Promise.resolve();
      p.then(function () { return post('/cart/add.js', { id: UBK, quantity: 1, properties: { '_fa-info': GIFT } }); }).then(done, fail);
      return;
    }
    if (!qual && s) setSt('');                         // nothing qualifying left: forget the state so the next qualifier re-offers
  }

  function onChange() { getCart().then(reconcile).catch(function () {}); }

  // The theme fires no cart event on a plain PDP add (verified 10-20: GHD kit page, real tap,
  // zero events) — so watch the cart WRITES themselves: any /cart/add|change|update|clear call
  // made through fetch, by any script (theme form, sheet, bundle cards, this watcher), is
  // followed by a reconcile. The event listeners stay as a second trigger.
  try {
    var _fetch = window.fetch;
    if (_fetch && !_fetch.__faUbk) {
      window.fetch = function () {
        var r = _fetch.apply(this, arguments);
        try {
          var a = arguments[0], u = String((a && a.url) || a || '');
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) r.then(function () { setTimeout(onChange, 200); }, function () {});
        } catch (e) {}
        return r;
      };
      window.fetch.__faUbk = 1;
    }
  } catch (e) {}
  document.addEventListener('cart:change', onChange);
  document.addEventListener('cart:after-change', onChange);
  document.addEventListener('cart:refresh', onChange);
  document.addEventListener('fa-cart:state', onChange);
  if (document.readyState !== 'loading') onChange();
  else document.addEventListener('DOMContentLoaded', onChange);
})();
